exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".messagesLink__messagesIconWrapper___1vqcC {\n  margin-right: 16px; }\n  @media (max-width: 576px) {\n    .messagesLink__messagesIconWrapper___1vqcC {\n      margin-left: 0;\n      margin-right: 16px; } }\n  .messagesLink__messagesIconWrapper___1vqcC .ant-badge-count {\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .messagesLink__messagesIconWrapper___1vqcC .messagesLink__messagesIcon___26dgI {\n    cursor: pointer;\n    margin-right: 0;\n    color: #3F3F3F;\n    transition: 300ms;\n    margin-bottom: -7px; }\n    .messagesLink__messagesIconWrapper___1vqcC .messagesLink__messagesIcon___26dgI:hover {\n      color: #F94144; }\n", ""]);

// exports
exports.locals = {
	"messagesIconWrapper": "messagesLink__messagesIconWrapper___1vqcC",
	"messagesIcon": "messagesLink__messagesIcon___26dgI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Header/MessagesLink/messagesLink.scss
// module id = 3979
// module chunks = 6